import {match, Pattern} from 'ts-pattern';

import type {Nullish} from 'shared/web';

export const SELLING_BUSINESS_CASE_TYPES = ['SELLING', 'SWAP'] as const;
export const PURCHASE_BUSINESS_CASE_TYPES = ['BUYING', 'PURCHASE_BROKERAGE'] as const;

export type CustomerInsightsBusinessCaseCategory = 'sale' | 'purchase' | 'unknown';

export const getCustomerInsightsBusinessCaseCategory = (
  businessCaseType: string | Nullish
): CustomerInsightsBusinessCaseCategory =>
  match(businessCaseType)
    .with(Pattern.union(...SELLING_BUSINESS_CASE_TYPES), () => 'sale' as const)
    .with(Pattern.union(...PURCHASE_BUSINESS_CASE_TYPES), () => 'purchase' as const)
    .otherwise(() => 'unknown' as const);
